import React from "react";

// Header Section Component
const Hero = () => {
  return (
    <div className="w-full  text-center mb-20">
      <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">
        We're Here to Help!
      </h1>
      <p className="text-white mb-1">Have questions or need assistance?</p>
      <p className="text-white">
        Our team is ready to support your business journey. Get in touch with us
        using the details below:
      </p>
    </div>
  );
};

export default Hero;
